// MRDetails.js
import React, { useState, useEffect } from "react";
import { decryptData } from "../../utils/storageCrypto";
const InfoItem = ({ label, children }) => (
  <div className="text-sm text-gray-600 flex items-center gap-2">
    <span className="text-gray-400">{label}:</span>
    <div className="font-medium text-gray-800">{children}</div>
  </div>
);

const MRDetails = ({ MR, onOpenVendors, FetchMRs, setPopupType, setMRStatusMessage, setShowPopup }) => {
  const [projects, setProjects] = useState([]);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  // Fetch projects related to customer
  const fetchCustomerProjects = async (customer_id) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(
        `${process.env.REACT_APP_FORE_APILINK}/projects/get-projects-by-customer?customer_id=${encodeURIComponent(
          customer_id
        )}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );

      const result = await response.json();
      if (result.success && Array.isArray(result.data)) {
        setProjects(result.data);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  // Update MR status
  const handleChangeStatus = async () => {
    if (!MR?._id) return;
    setUpdatingStatus(true);
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/update-mr-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
          body: JSON.stringify({
            _id: MR._id,
            status: "Verified", // New status
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        setMRStatusMessage("Material Requirement Verified Sucessfully")
        setPopupType("200or201")
        setShowPopup(true)
        FetchMRs(); // Refetch the MRs to update UI
        setTimeout(() => {
    setShowPopup(false);
  }, 2000);
      } else {
        alert("Failed to update status: " + data.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setUpdatingStatus(false);
    }
  };

  return (
    <div className="p-4 relative bg-white rounded-lg shadow">
      <div className="flex items-center justify-between gap-4">
        {/* Left: MR Info */}
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-semibold text-gray-900 truncate">
            {MR?.mr_number || ""}
          </h2>

          <div className="mt-3 flex flex-wrap gap-4 items-center">
            <InfoItem label="Project">
              {MR?.project_id?.projectName || "---"}
            </InfoItem>

            <InfoItem label="Status">{MR?.status || "N/A"}</InfoItem>

            <InfoItem label="Categories">
              {MR?.product_categories?.map((cat, idx) => (
                <span
                  key={idx}
                  className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full mr-1"
                >
                  {cat.product_category_name}
                </span>
              ))}
            </InfoItem>

            <button
              onClick={onOpenVendors}
              className="flex items-center gap-2 px-3 py-1 rounded-md border border-gray-200 hover:bg-gray-50"
              title="View / assign vendors"
            >
              <span className="text-sm text-gray-500">Vendors</span>
              <span className="inline-block bg-blue-50 text-blue-700 text-sm font-medium px-2 py-0.5 rounded">
                {MR?.vendor_ids?.length || 0}
              </span>
            </button>
          </div>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-2">
          {MR?.status === "Received" && (
            <button
              onClick={handleChangeStatus}
              disabled={updatingStatus}
              className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700 transition"
            >
              {updatingStatus ? "Updating..." : "Mark as Verified"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MRDetails;
